import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ROUTES } from '@client/pages/routes';
import ContactBoxes from '@client/containers/contactBoxes/ContactBoxes';
import TheTeamSection from '@client/containers/theTeamSection/TheTeamSection';
import SlideshowSection from '@client/containers/slideshowSection/SlideshowSection';
import PhoneticsSection from '@client/containers/phoneticsSection/PhoneticsSection';
import headerAbout from '@client/shared/styles/assets/images/header_about.jpg';
import headerAboutMobile from '@client/shared/styles/assets/images/header_about_mobile.png';
import hero_mission1 from '@client/shared/styles/assets/images/hero_mission1.jpg';
import hero_mission2 from '@client/shared/styles/assets/images/hero_mission2.png';
import hero_mission3 from '@client/shared/styles/assets/images/hero_mission3.png';
import hero_mission4 from '@client/shared/styles/assets/images/hero_mission4.png';
import hero_mission5 from '@client/shared/styles/assets/images/hero_mission5.png';
import { strings } from '@client/localization/Localization';
import HeroSection from '@client/containers/heroSection/HeroSection';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import shapes from '@client/shared/js/shapes';
import styles from './aboutPage.scss';

const missions = [
  {
    title: 'Mission #1',
    description:
      'We believe positive stories need their own place in a world full of negativity and fake news. We’re convinced stories and curiosity have the power to change our point of view. And from there who knows what can happen?',
    heroImageUrl: `${hero_mission1}`,
    id: 'Mission 1',
  },
  {
    title: 'Mission #2',
    description:
      'We focus on stories from the worlds of science, tech and innovation. Because it’s there we discover brilliance, exciting possibilities and new perspectives. Sharing stories about science lies at the core of our mission.',
    heroImageUrl: `${hero_mission2}`,
    id: 'Mission 2',
  },
  {
    title: 'Mission #3',
    description:
      'People who are different, people who drive change, those that make us think and smile inspire us.',
    heroImageUrl: `${hero_mission3}`,
    id: 'Mission 3',
  },
  {
    title: 'Mission #4',
    description:
      'We cover stories about nature because we depend on our planet. We explore the untold and overlooked in people and places. We never follow the mainstream.',
    heroImageUrl: `${hero_mission4}`,
    id: 'Mission 4',
  },
  {
    title: 'Mission #5',
    description:
      'We embrace democratic values such as diversity, sustainability and community. But we also know we need to fight for them everyday. We take up this fight willingly through our stories. ',
    heroImageUrl: `${hero_mission5}`,
    id: 'Mission 5',
  },
];

class AboutPage extends PureComponent {
  constructor(props) {
    super(props);
    this.contactRef = createRef();
  }

  componentDidMount() {
    const { location } = this.props;

    this.scrollToSection(location);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.key !== prevProps.location.key) {
      this.scrollToSection(location);
    }
  }

  scrollToSection = (location) => {
    if (location.pathname === ROUTES.contact) {
      window.scrollTo(0, this.contactRef.current.offsetTop);
    } else if (location.pathname === ROUTES.about) {
      window.scrollTo(0, 0);
    }
  };

  render() {
    return (
      <div className={styles.aboutPage}>
        <HeroSection
          className={`${themeStyles.hideOnMobile} ${styles.heroSection}`}
          title={strings.aboutUsHeroTitle}
          description={strings.aboutUsHeroDescription}
          imageUrl={headerAbout}
          graphicsHeroMobile={shapes.graphic_about_mobile}
          graphicsHero={shapes.graphic_header_2}
        />
        <HeroSection
          className={themeStyles.hideOnDesktop}
          title={strings.aboutUsHeroTitle}
          description={strings.aboutUsHeroDescription}
          imageUrl={headerAboutMobile}
          graphicsHeroMobile={shapes.graphic_about_mobile}
          graphicsHero={shapes.graphic_header_2}
        />
        <PhoneticsSection
          title={strings.aboutUsPhoneticsWord}
          phonetics={strings.aboutUsPhonetics}
          description={strings.aboutUsPhoneticsDescription}
          backgroundLines={true}
        />
        <SlideshowSection
          slides={missions}
          hideEpisodeCount={true}
          textBoxStyle={styles.missionsTextBox}
          className={styles.slideshowSection}
        />
        <TheTeamSection />
        <div ref={this.contactRef} />
        <ContactBoxes />
      </div>
    );
  }
}

AboutPage.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  phonetics: PropTypes.string,
  location: PropTypes.object,
};

export default withRouter(AboutPage);
